export const companiesFieldFilterFunction = (fieldName: string) => !['period'].includes(fieldName);
